import { useQuery } from "@tanstack/react-query";
import api from "@/services/api";

const FEATURE_FLAG_URL = "/fulfilment/accounts-payable/api/v1/vip/feature-flags";

async function fetchWalletFlag(): Promise<boolean> {
  const res = await api.post(FEATURE_FLAG_URL, { features: ["vip_wallet"] });
  return res?.vip_wallet === "allow";
}

/**
 * Returns true when the "vip_wallet" feature flag is enabled for the current user.
 * Same pattern as usePaymentFlag — 5-min cache, no retry, fail-safe false — but a
 * separate flag, so the wallet can be released after Payments.
 *
 * VIP resolves it as the Unleash toggle `tars.<env>.vip_wallet`.
 *
 * `enabled: false` skips the request and reads as false. Used by callers that
 * render app-wide (the header) so the flag is only fetched where it matters.
 */
export function useWalletFlag(options?: { enabled?: boolean }): boolean {
  const { data: isEnabled = false } = useQuery(
    ["invoiceFeatureFlag", "vip_wallet"],
    fetchWalletFlag,
    {
      staleTime: 5 * 60 * 1000,
      retry: false,
      enabled: options?.enabled !== false,
    },
  );
  return isEnabled;
}
